export const ExpenseseQueryKeys = {
  all: ['fields'] as const,
  lists: () => [...ExpenseseQueryKeys.all, 'list'] as const,
  list: (filters: object) => [...ExpenseseQueryKeys.lists(), filters] as const,
  details: () => [...ExpenseseQueryKeys.all, 'detail'] as const,
  detail: (id: string) => [...ExpenseseQueryKeys.details(), id] as const,
};
